import { render, staticRenderFns } from "./Distances.vue?vue&type=template&id=5288c878&"
import script from "./Distances.vue?vue&type=script&lang=ts&"
export * from "./Distances.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports